<button
  class="nav-link dropdown-toggle"
  role="button"
  data-bs-toggle="dropdown"
  data-bs-display="dynamic"
  aria-expanded="false"
>
  Tax Certification
</button>
<ul class="dropdown-menu dropdown-simple" style="min-width: 360px" data-bs-popper="static">

  @if (taxCertTabPermissions.viewTaxCertificationsPermission | checkPermissions) {
    <li>
      <a
        class="dropdown-item"
        routerLink="tax-certification-submissions"
        routerLinkActive="active"
        >Submissions</a
      >
    </li>
  }

  @if (taxCertTabPermissions.viewQuickUpdates | checkPermissions) {
    <li>
      <a
        routerLink="bo-positions-overview"
        class="dropdown-item"
        routerLinkActive="active"
        >Quick updates</a
      >
    </li>
  }

  @if (taxCertTabPermissions.viewTaxCertificationsPermission | checkPermissions) {
    <li>
      <a
        class="dropdown-item"
        routerLink="tax-certification-submissions-data"
        routerLinkActive="active"
        >Submission Data</a
      >
    </li>
  }

  @if (taxCertTabPermissions.viewDownstreamPositionsPermission | checkPermissions) {
    <li>
      <a
        class="dropdown-item"
        routerLink="downstream-positions"
        routerLinkActive="active"
        >Downstream Position Confirmations</a
      >
    </li>
  }

</ul>
